import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3 className="footer-logo">SOUL ALIGNED</h3>
            <p className="footer-tagline">
              Transforming lives through holistic healing & spiritual guidance
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-section">
              <h4 className="footer-heading">Services</h4>
              <ul className="footer-list">
                <li><a href="#services">NLP Coaching</a></li>
                <li><a href="#services">Reiki Healing</a></li>
                <li><a href="#services">Akashic Records</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4 className="footer-heading">Information</h4>
              <ul className="footer-list">
                <li><a href="#about">About</a></li>
                <li><a href="#testimonials">Testimonials</a></li>
                <li><a href="#faq">FAQ</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4 className="footer-heading">Connect</h4>
              <p className="footer-text">
                Ready to begin your transformation journey?
              </p>
              <button onClick={scrollToTop} className="btn-secondary btn-small">
                Book a Session
              </button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Soul Aligned. All rights reserved.
          </p>
          <p className="footer-made-with">
            Made with <Heart size={14} fill="currentColor" /> for transformation
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
